import * as React from 'react';
import { Component } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  __,
  dateFrom,
  dateTimeFrom,
  getActiveStage,
  getURLParam,
  mapStateToProps,
  redirect,
  setTableParams,
} from '../../core/utils';
import Table from '../../components/Table';
import styles from '../../styles/views/space_allocation/Buildings.scss';
import { setPlusActions } from '../../redux/actions/general/plus';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import * as _ from 'lodash';
import Tooltip from '../../components/Tooltip';
import { getTeamsPermissions } from '../../redux/actions/table/teams';
import { setNotification } from '../../redux/actions/general/notification';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import {
  deleteBuildings,
  listBuildings,
  readBuilding,
} from '../../redux/actions/table/buildings';
import BuildingsFlyout from '../../flyouts/buildings/BuildingsFlyout';
import TableNA from '../../components/TableNA';
import classNames from 'classnames';
import ArrowDoubleRightSmallIcon from '../../assets/images/arrow-double-right-small-15x15.svg';
import Avatar from '../../components/Avatar';

@mapStateToProps((state) => ({
  table: state.table['buildings'],
}))
class Buildings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: null,
    };
  }

  componentDidMount() {
    getTeamsPermissions(this.props.match.params.stage).then(({ response }) => {
      this.setState({ team_roles: _.get(response.data, 'teams', {}) });

      !_.isEmpty(this.state.team_roles.editor) &&
        setPlusActions([
          {
            title: __('space-allocation.buildings.table.button.create'),
            onClick: () =>
              setTableParams('buildings', {
                add_building_wizard: true,
              }),
          },
        ]);
    });

    enableProjectsDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/space_allocation/buildings')
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect('/stages/' + stage_id + '/space_allocation/buildings')
    );

    createSidebar({
      title: __('submenu.title.space-allocation'),
      items: [
        {
          title: __('submenu.title.space-allocation.rooms'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/rooms',
        },
        {
          title: __('submenu.title.space-allocation.room-types'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/room_types',
        },
        {
          title: __('submenu.title.space-allocation.room-groups'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/room_groups',
        },
        {
          title: __('submenu.title.space-allocation.zones'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/zones',
        },
        {
          title: __('submenu.title.space-allocation.entrances'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/entrances',
        },
        {
          title: __('submenu.title.space-allocation.expansion-joints'),
          link: () =>
            '/stages/' +
            getActiveStage() +
            '/space_allocation/expansion_joints',
        },
        {
          title: __('submenu.title.space-allocation.storeys'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/storeys',
        },
        {
          title: __('submenu.title.space-allocation.buildings'),
          link: () =>
            '/stages/' + getActiveStage() + '/space_allocation/buildings',
          active: true,
        },
        {
          title: __('submenu.title.space-allocation.sites'),
          link: () => '/stages/' + getActiveStage() + '/space_allocation/sites',
        },
      ],
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.table.clicked_row &&
      this.props.table.clicked_row !== prevProps.table.clicked_row
    ) {
      if (!prevProps.table.clicked_row) {
        this.setState({ preview: undefined });
      }

      readBuilding(this.props.table.clicked_row).then(({ response }) => {
        this.setState({ preview: response.data });
      });
    }
  }

  render() {
    const columns = [
      {
        key: 'code',
        name: __('buildings.field.code'),
        default: true,
        width: 100,
      },
      {
        key: 'title',
        name: __('buildings.field.title'),
        required: true,
        sortable: false,
      },
      {
        key: 'site',
        name: __('buildings.field.site'),
        width: 150,
        value: (site) =>
          site ? <Tooltip text={site}>{site}</Tooltip> : <TableNA />,
        sortable: false,
      },
      {
        key: 'rooms',
        name: __('buildings.field.rooms'),
        value: (rooms, row) => (
          <div
            className={classNames(styles.rooms)}
            onClick={() => {
              setTableParams(
                'rooms',
                _.transform(
                  [
                    'filter.site',
                    'filter.building',
                    'filter.storey',
                    'filter.expansion_joint',
                    'filter.entrance',
                    'filter.zone',
                    'filter.functional_space',
                    'filter.foh',
                    'filter.outdoor',
                    'filter.room_group',
                    'filter.room_type',
                    'filter.security',
                    'filter.date',
                    'filter.creator',
                    'query',
                  ],
                  (filters, filter) => {
                    filters[filter] = '';

                    return filters;
                  },
                  {}
                )
              );

              redirect(
                '/stages/' +
                  this.props.match.params.stage +
                  '/space_allocation/rooms?filter.building=' +
                  row.id
              );
            }}
          >
            {rooms}
            <ArrowDoubleRightSmallIcon />
          </div>
        ),
        width: 60,
        sortable: false,
      },
      {
        key: 'created_at',
        name: __('buildings.field.created-at'),
        value: (created_at) => (
          <Tooltip text={dateTimeFrom(created_at)}>
            {dateFrom(created_at)}
          </Tooltip>
        ),
        width: 80,
      },
      {
        key: 'created_by',
        name: __('buildings.field.created-by'),
        value: (user) => (
          <Avatar
            avatar_url={user.avatar_url}
            name={user.fullname}
            active={user.active}
          />
        ),
        width: 50,
      },
    ];

    const singleActions = (building_id) => {
      return [
        <Tooltip
          text={__('buildings.tooltip.building-properties')}
          key={_.uniqueId()}
        >
          <InfoPositiveIcon
            className=''
            onClick={(e) => {
              e.stopPropagation();

              setTableParams('buildings', {
                clicked_row: building_id,
                actioned_row: undefined,
              });
            }}
          />
        </Tooltip>,
        <Tooltip
          text={__('buildings.tooltip.delete-building')}
          key={_.uniqueId()}
        >
          <DeleteIcon
            onClick={(e) => {
              e.stopPropagation();

              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: __('buildings.alert.delete-confirmation'),
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-delete'),
                    onClick: () => {
                      deleteBuildings([building_id]).then(() => {
                        hideAlertbox();

                        setNotification(__('buildings.alert.deleted'));
                        listBuildings(this.props.match.params.stage);

                        setTableParams('buildings', {
                          actioned_row: undefined,
                        });
                      });
                    },
                  },
                ],
              });
            }}
          />
        </Tooltip>,
      ];
    };

    const groupActions = (building_ids) => [
      <Tooltip
        text={__('buildings.tooltip.delete-selected-buildings')}
        key={_.uniqueId()}
      >
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();

            showAlertbox({
              color: 'red',
              title: __('general.alert.are-you-sure'),
              description: __('buildings.alert.multiple-delete-confirmation'),
              buttons: [
                {
                  color: 'lightGray',
                  text: __('general.alert.no-close'),
                  onClick: 'close',
                },
                {
                  color: 'gray',
                  text: __('general.alert.yes-delete'),
                  onClick: () => {
                    deleteBuildings(building_ids).then(() => {
                      hideAlertbox();

                      setNotification(__('buildings.alert.multiple-deleted'));
                      listBuildings(this.props.match.params.stage);

                      setTableParams('buildings', {
                        selected_rows: [],
                      });
                    });
                  },
                },
              ],
            });
          }}
        />
      </Tooltip>,
    ];

    const preview = (
      <BuildingsFlyout
        data={this.state.preview}
        readAction={(building_id) => {
          return new Promise((resolve) => {
            readBuilding(getURLParam('id') || building_id).then(
              ({ response }) => {
                this.setState({ preview: response.data });

                resolve(response);
              }
            );
          });
        }}
      />
    );

    return (
      <Table
        listAction={() => listBuildings(this.props.match.params.stage)}
        name='buildings'
        title={__('submenu.title.space-allocation.buildings')}
        singleActions={singleActions}
        groupActions={groupActions}
        columns={columns}
        preview={this.state.preview ? preview : []}
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default Buildings;
